import { render } from "./App.vue?vue&type=template&id=3973cf06&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=3973cf06&lang=scss"
import "./App.vue?vue&type=style&index=1&id=3973cf06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3973cf06"

export default script